import { render, staticRenderFns } from "./AddMedicine.vue?vue&type=template&id=c8f42cd4&scoped=true"
import script from "./AddMedicine.vue?vue&type=script&lang=js"
export * from "./AddMedicine.vue?vue&type=script&lang=js"
import style0 from "./AddMedicine.vue?vue&type=style&index=0&id=c8f42cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f42cd4",
  null
  
)

export default component.exports